import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./PropertySingleLine.css";
//import properties from "../properties.json";
import { SavedRow, PropertyImage, SortMode, DisplayMode } from "../types";
import { formatPrice, toS3Image, formatDecimalNumber } from "../Utils";
import { createGoogleMapsLink } from "../Utils";
import FlatGallery from "../FlatGallery";
import { ImageGalleryEntry } from "../FlatGallery";
import { WhatToPrint } from "../types";
import { shouldPrintImages } from "../WhatToPrint";
import { PropertyAPI } from "../lib/property-api";
import { PropertySource } from "../lib/property-api";
import { get_source } from "../lib/source";


interface Props {
  property_id: string;
  sort_mode: SortMode;
  display_mode: DisplayMode;
  what_to_print: WhatToPrint;
  on_done_rendering: (property_id: string) => void;
  source: PropertySource;
}
function presentHalfBaths(br: number | null): string {
  if (br === null || br <= 0) {
    return "";
  }
  return String(br);
}

function presentYearBuilt(yr: number | null): string {
  if (yr === null || yr <= 0) {
    return "";
  }
  return String(yr);
}

function daysSince(dateString: string): number {
  const inputDate = new Date(dateString);
  const today = new Date();

  // Set both dates to start of the day to avoid partial day issues
  inputDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffTime = today.getTime() - inputDate.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
}
function presentDaysOnMarket(d: number | null): string {
  if (d === null || d < 0) {
    return "";
  }
  return String(d);
}

function presentMlsStatus(s: string | null) {
  if (!s) {
    return "";
  }
  s = s.toLowerCase();
  if (s === "expired") {
    return <b className="pslpdf-expired">EXPIRED</b>;
  }
  if (s === "withdrawn") {
    return <b className="pslpdf-withdrawn">WITHDRAWN</b>;
  }
  if (s === "sold") {
    return <b className="pslpdf-sold">SOLD</b>;
  }
  if (s === "active" || s === "pending") {
    return <b className="pslpdf-active">ACTIVE</b>;
  }
  return s;
}
function presentablePropertyID(k: string): string {
  return `#${k.replace(/^KEY/, "")}`;
}
function presentPropertyType(k: string | null): string {
  if (!k) {
    return "";
  }
  switch (k.toLowerCase()) {
    case "residential income":
      return "RINC";
    case "residential":
      return "RESI";
    case "land":
      return "LAND";
    case "commercial sale":
      return "COMS";
    case "business opportunity":
      return "BUSO";
    default:
      return k;
  }
}
function presentPropertySubType(k: string | null| string[]): string {
  if (!k) {
    return "";
  }
  if(Array.isArray(k)){
    return k.join(',');
  }
  switch (String(k).toLowerCase()) {
    case "duplex":
      return "DUPLEX";
    case "single family residence":
      return "SIFARE";
    case "condominium":
      return "CONDO";
    case "stock cooperative":
      return "STOCCO";
    case "unimproved land":
      return "UNILAN";
    case "multi family":
      return "MULFAM";
    case "triplex":
      return "TRIPLE";
    case "mobile home":
      return "MOBHOM";
    case "quadruplex":
      return "QUADRU";
    default:
      return k;
  }
}
const EMPTY_PROFILE_IMAGE: string =
  "https://lombardo.nyc3.digitaloceanspaces.com/mls/no-img.png";

function PropertySingleLine(props: Props) {
  const [data, setData] = React.useState<SavedRow|null>();
  const [propertyID, setPropertyID] = React.useState<string>(props.property_id);
  const [street, setStreet] = React.useState<string>("");
  const [cityStateZip, setCityStateZip] = React.useState<string>("");
  const [beds, setBeds] = React.useState<number | null>(null);
  const [baths, setBaths] = React.useState<number | null>(null);
  const [fullBaths, setFullBaths] = React.useState<number | null>(null);
  const [halfBaths, setHalfBaths] = React.useState<number | null>(null);
  const [squareFeet, setSquareFeet] = React.useState<string | null>(null);
  const [prettyPrice, setPrettyPrice] = React.useState<string>("");
  const [listingKey, setListingKey] = React.useState<string>("");
  const [mlsStatus, setMlsStatus] = React.useState<string | null>(null);
  const [error, setError] = React.useState<string | null>(null);
  const [image, setImage] = React.useState<PropertyImage | null>(null);
  const [propertyType, setPropertyType] = React.useState<string | null>(null);
  const [propertySubType, setPropertySubType] = React.useState<string | null>(
    null
  );
  const [googleMapsLink, setGoogleMapsLink] = React.useState<URL>(
    new URL("https://maps.google.com")
  );
  const [mlsLink, setMlsLink] = React.useState<URL>(
    new URL("https://lombardohomesandrealestates.com")
  );
  const [lotSize, setLotSize] = React.useState<string>("");
  const [yearBuilt, setYearBuilt] = React.useState<number | null>(null);
  const [daysOnMarket, setDaysOnMarket] = React.useState<number>(-1);
  const [priceDirection, setPriceDirection] = React.useState<string>("");
  const [showFlatGallery, setShowFlatGallery] = React.useState<boolean>(true);
  const [address, setAddress] = React.useState<string>("");
  const [api,_] = React.useState<PropertyAPI>(new PropertyAPI());


  function updateCurrentImage(id: string, image: string) {
    const interval = window.setInterval(() => {
      const ele = document.getElementById(id);
      if (ele) {
        ele.style.backgroundImage = `url('${image}')`;
        window.clearInterval(interval);
      }
    }, 80);
  }
  React.useEffect(() => {
    const u: URL = new URL("https://lombardohomesandestates.com/");
    const is_staging: boolean = window.location.pathname.includes("/staging/");
    if (is_staging) {
      u.pathname = "/staging/";
    } else {
      u.pathname = "/mls-properties/";
    }
    u.searchParams.set("viewMode", "icons");
    u.searchParams.set("displayMode", "property");
    u.searchParams.set("listing", props.property_id);
    setMlsLink(u);
    if (typeof global.lombardo === "undefined") {
      global.lombardo = {
        selected: [],
      };
    }
    setShowFlatGallery(shouldPrintImages(props.what_to_print));
  }, []);
  React.useEffect(() => {
    setPropertyID(props.property_id);

    (async () => {
      const s: SavedRow|null = await api.get_property_by_source(props.property_id,get_source());
      setData(s);
      if (s === null) {
        setError("Unable to find the listing you were looking for.");
      }
    })();
    if (!data){
      setError("Unable to find the listing you were looking for.");
      return;
    }
    setYearBuilt(data.YearBuilt);
    setError(null);
    setGoogleMapsLink(createGoogleMapsLink(data));
    let media_length: number = 0;
    if (Array.isArray(data.Media)) {
      media_length = data.Media.length;
    } else {
      media_length = 0;
    }

    const thumb_id: string = `prop-thumbnail-${props.property_id}`;
    // This whole block might be unneeded
    if (media_length > 0) {
      let image: PropertyImage | null = null;
      for (const media of data.Media) {
        try {
          if (Number(media.Order) === 0) {
            image = toS3Image(media.MediaURL, media.Order, props.source);
            setImage(image);
            break;
          }
        } catch (err) {}
      }
      if (image === null) {
        for (const media of data.Media) {
          try {
            setImage(toS3Image(media.MediaURL, media.Order, props.source));
            break;
          } catch (err) {
            console.error({err});
          }
        }
      }
      if (image) {
        updateCurrentImage(thumb_id, image.thumb.toString());
      }
    } else {
      updateCurrentImage(thumb_id, EMPTY_PROFILE_IMAGE);
    }
    if (typeof data.ListingKey !== "undefined") {
      if (String(data.ListingKey).match(/^KEY/)) {
        setListingKey(String(data.ListingKey).replace(/^KEY/, ""));
      } else {
        setListingKey(data.ListingKey);
      }
    }
    if (typeof data.MlsStatus !== "undefined") {
      setMlsStatus(data.MlsStatus);
    }
    {
      const sqft: string = data.LotSizeDimensions;
      setLotSize(sqft);
    }
    const sqft: string = formatDecimalNumber(data.LotSizeSquareFeet);
    if (sqft === "-1") {
      setSquareFeet(null);
    } else {
      setSquareFeet(sqft);
    }
    if (
      typeof data.BathroomsFull === "undefined" ||
      Number(data.BathroomsFull) === 0
    ) {
      setBaths(null);
    } else {
      setBaths(data.BathroomsFull);
      setFullBaths(data.BathroomsFull);
    }
    let half_baths: number = 0;
    if (
      typeof data.BathroomsHalf !== "undefined" ||
      Number(data.BathroomsHalf) > 0
    ) {
      half_baths = Number(data.BathroomsHalf);
      setHalfBaths(half_baths);
    }
    if (
      typeof data.BedroomsTotal === "undefined" ||
      Number(data.BedroomsTotal) === 0
    ) {
      setBeds(null);
    } else {
      let baths: number = Number(data.BedroomsTotal);
      if (half_baths) {
        baths += half_baths;
      }
      setBeds(baths);
    }
    let compiled_street: string[] = [];
    if (
      typeof data.StreetNumber !== "undefined" &&
      String(data.StreetNumber) !== "undefined"
    ) {
      compiled_street.push(String(data.StreetNumber));
    }
    if (
      typeof data?.StreetName !== "undefined" &&
      String(data.StreetName) !== "undefined"
    ) {
      compiled_street.push(String(data.StreetName));
    }
    if (
      typeof data?.StreetSuffix !== "undefined" &&
      String(data.StreetSuffix) !== "undefined"
    ) {
      compiled_street.push(String(data.StreetSuffix));
    }
    setStreet(compiled_street.join(" "));
    let compiled_state: string[] = [];
    if (
      typeof data.PostalCity !== "undefined" &&
      String(data.PostalCity) !== "undefined"
    ) {
      compiled_state.push(String(data.PostalCity));
    }
    if (
      typeof data.StateOrProvince !== "undefined" &&
      String(data.StateOrProvince) !== "undefined"
    ) {
      compiled_state.push(String(data.StateOrProvince));
    }
    if (
      typeof data.PostalCode !== "undefined" &&
      String(data.PostalCode) !== "undefined"
    ) {
      compiled_state.push(String(data.PostalCode));
    }
    setCityStateZip(compiled_state.join(" "));
    setPrettyPrice(formatPrice(data.ListPrice));
    setPropertyType(data.PropertyType);
    setPropertySubType(data.PropertySubType);
    let unit_number: string | null = null;
    if (typeof data.UnitNumber !== "undefined" && data.UnitNumber !== null) {
      unit_number = data.UnitNumber;
    }
    if (
      data.OnMarketDate !== null &&
      String(data.OnMarketDate).match(/^\d{4}-\d{2}-\d{2}$/)
    ) {
      setDaysOnMarket(daysSince(String(data.OnMarketDate)));
    }
    if (String(data["KEY_MlsMajorChangeType"]) === "Price Decrease") {
      setPriceDirection("down");
    }
    if (String(data["KEY_MlsMajorChangeType"]) === "Price Increase") {
      setPriceDirection("up");
    }
    if(typeof data.UnitNumber !== 'undefined' && data.UnitNumber !== null){
      unit_number = `#${data.UnitNumber}`;
    }
    if(unit_number){
      setAddress(
        `${data.StreetNumber} ${data.StreetName} ${unit_number} ${data.StreetSuffix} ${data.PostalCity}, ${data.StateOrProvince} ${data.PostalCode}`
      );
    }else{
      setAddress(
        `${data.StreetNumber} ${data.StreetName} ${data.StreetSuffix} ${data.PostalCity}, ${data.StateOrProvince} ${data.PostalCode}`
      );
    }
  }, [data, propertyID, error]);
  function entry(label: string, stuff: any,added_class?: string) {
    return (
      <div className={"pslpdf-entry " + (added_class ? added_class : "")}>
        <div className="pslpdf-entry-label">{label}</div>
        <div className="pslpdf-entry-content">{stuff}</div>
      </div>
    );
  }
  return (
    <div className="PropertySingleLinePDFWrapper" id={"psl-load-hack-" + props.property_id.replace(/[^a-z0-9]+/gi,'')}>
      <div className="pslpdf-address">
        {address}
      </div>
      <div className="PropertySingleLinePDF">
        {entry(
          "MLS#",
          <a href={mlsLink.toString()} target="_blank">
            {presentablePropertyID(propertyID)}
          </a>
        )}
        {entry("Status", presentMlsStatus(mlsStatus))}
        {entry("Price Increase", priceDirection === "up" ? "Yes" : "No")}
        {entry("Price", prettyPrice)}
        {entry("Property Type", presentPropertyType(propertyType))}
        {entry("Property Sub-Type", presentPropertySubType(propertySubType))}
        {entry("Street", street)}
        {entry("City/State/Zip", cityStateZip)}
        {entry("Square Feet", squareFeet)}
        {entry("Lot Size", lotSize)}
        {entry("Beds", beds)}
        {entry("Full Baths", fullBaths)}
        {entry("Half Baths", presentHalfBaths(halfBaths))}
        {entry("Beds", beds)}
        {entry("Year Built", presentYearBuilt(yearBuilt))}
        {entry("Days On Market", presentDaysOnMarket(daysOnMarket))}
        {entry('Google Maps',(<a href={googleMapsLink.toString()} target="_blank">{googleMapsLink.toString()}</a>),'pslpdf-lhe-link')}
        {entry('Lombardo Homes & Estates Link',(<a href={mlsLink.toString()} target="_blank">{mlsLink.toString()}</a>),'pslpdf-lhe-link')}
        <div className="pslpdf-flat-gallery-wrapper">
          {shouldPrintImages(props.what_to_print) && showFlatGallery && (
            <FlatGallery
              property_id={props.property_id}
              loaded_image={(current: ImageGalleryEntry) => {
                global.lombardo.rendered.push(current);
              }}
              source={get_source()}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default PropertySingleLine;
